import React from "react"
import {
  Caret,
  DropdownEntry,
  NavbarDropdownColumn,
  NavbarDropdownMenu,
  NavbarLinkText,
  NavbarLinkWrapper,
  NavbarVerticalContainer,
  ProductLink,
} from "./styles"
import { ReactComponent as Chevron } from "@images/chevron.svg"
import Flex from "@components/elements/flex"
import Span from "@components/elements/span"
import { ReactComponent as KlipsLogo } from "@images/comparison/klips.svg"
import { useTheme } from "styled-components"
import { ReactComponent as PowerMetricsCircle } from "@images/icons/powermetrics-circle.svg"

const ProductsGrid = ({ mobile }) => {
  const { color } = useTheme()

  return (
    <>
      <Flex gap="1rem">
        <ProductLink
          link={"/klips"}
          logo={<KlipsLogo height="34px" />}
          background={color.blueLight}
          description={
            <p>
              Connect to hundreds of services and APIs directly and build highly
              customizable dashboards and reports for your team and clients.
            </p>
          }
          links={[
            {
              name: "Overview",
              link: "/klips",
            },
            {
              name: "Integrations",
              link: "/klips/integrations",
            },
            {
              name: "Client Reporting",
              link: "/klips/partners",
            },
            {
              name: "Live Dashboards",
              link: "https://www.klipfolio.com/live-dashboards",
            },
            {
              name: "Pricing",
              link: "/pricing",
            },
            {
              name: "What's New",
              link: "/whats-new",
            },
          ]}
          linkColor="#3EA3BF"
        />
      </Flex>

      <NavbarVerticalContainer>
        <NavbarDropdownColumn vertical={!mobile} as="ul">
          <DropdownEntry
            name="PowerMetrics"
            title
            link="https://www.powermetrics.app/"
            newTab
            image={<PowerMetricsCircle />}
            style={{ margin: ".5rem 0 auto" }}
          />
        </NavbarDropdownColumn>
      </NavbarVerticalContainer>
    </>
  )
}

export const DesktopProductsMenu = React.memo(({ caretTranslate }) => {
  return (
    <NavbarLinkWrapper id={`menu-products-desktop`}>
      <NavbarLinkText hasDropdown title={"Product"}>
        Product&nbsp;
        <Chevron width={9} height={7} />
        <Caret style={{ bottom: caretTranslate }} />
      </NavbarLinkText>
      <NavbarDropdownMenu>
        <ProductsGrid />
      </NavbarDropdownMenu>
    </NavbarLinkWrapper>
  )
})

DesktopProductsMenu.displayName = "Desktop Products Menu"

export const MobileProductsMenu = React.memo(() => {
  return (
    <NavbarLinkWrapper>
      <Flex gap="1rem">
        <Span color="#333" fontWeight={700}>
          Product
        </Span>
        <ProductsGrid mobile />
      </Flex>
    </NavbarLinkWrapper>
  )
})

MobileProductsMenu.displayName = "Mobile Products Menu"
